import React, { useEffect, useRef } from "react";
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import Icon from "@components/Icon";
import Text from "@components/Text";


const ModalContainer = styled.div<StyledProps>`
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  overflow-x: hidden;
  background-color: rgba(51, 51, 51, 0.85);
  pointer-events: none;
  opacity: 0;
  transition: opacity 500ms ease;
  box-shadow: none;
`

const ModalContent = styled.div<StyledProps>`
  overflow-x: hidden;
  position: relative;
  width: 100%;
  max-width: 660px;
  max-height: 620px;
  min-height: 180px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  padding: 30px 20px;
  align-self: center;
  box-shadow: none;
  opacity: 0;
  transition: opacity 300ms ease, transform 300ms 250ms ease;
  // transform: scale(0);
  display: flex;
`
const Body = styled.div<StyledProps>`
  background-color: ${props => props.theme?.colors.white + ''};
  width: 100%;
  margin: 0;
  padding: 20px;
  overflow-y: auto;
  border-radius: 4px;
  @media screen and (min-width: 768px) {
    padding: 30px;
  }
`
const visable = css`
  pointer-events: auto;
  opacity: 1;
  transition: all 300ms ease-in-out;
`

const visableContent = css`
  opacity: 1;
  // transform: scale(1);
  transition: opacity 300ms ease, transform 500ms 500ms ease;
`
const ModifyIcon = css`
  margin-left: 10px;
  height: 12px;
  width: 12px;
`

const CloseButton = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 20px;
  margin-top: -30px;
  font-weight: bold;
  cursor: pointer;
  align-items: center;
`


interface StyledProps {
  theme?: ITheme;
}

export interface ModalProps {
  children?: React.ReactNode
  show: boolean;
  onClose: () => void;
  theme?: ITheme;
  className?: string | undefined;
}

function Modal({ children, show, onClose, className }: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const contentModalRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  useEffect(() => {
    if(!modalRef.current || !contentModalRef.current) {
      return
    }
    if (show) {
      modalRef?.current.classList.add(visable);
      contentModalRef.current.classList.add(visableContent);
    } else {
      modalRef.current.classList.remove(visable);
      contentModalRef.current.classList.remove(visableContent);
    }
  }, [show]);
  return <ModalContainer ref={modalRef} theme={theme} className={className}>
    <ModalContent ref={contentModalRef} className="modal-content">
      <CloseButton onClick={()=> {onClose()}}> <Text fontWeight="bold" color={theme.colors.white}>Close</Text> <Icon className={ModifyIcon} name="cancel-white" size="sm" /> </CloseButton>
      <Body theme={theme} className="modal-body">
        {children}
      </Body>
    </ModalContent>
  </ModalContainer>;
};

Modal.defaultProps = {
  show: false,
  onClose: () => {}
}

export default Modal;
